import React, { useEffect } from "react"
import { toast } from "react-toastify"
import { Note } from "../../../Component/Model/Dto/Note";
import { defaultObject } from "../../../Component/Model/helpers";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { NoteModal } from "./NoteModal";
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import AppAccordion from '../../../Component/Common/Components/Accordion/AppAccordion';
import { NotesTableMapper } from "./NotesTableColumn";
import { NoteService } from "../../../Component/Api/Note/NoteService";
import { ColumnSortOption, SortDirections } from '../../../Component/Model/Dto/ColumnSortOption';

interface IProps {
    linkedEntityId: string;
    scorecardId: string;
    scorecardElement: number;
    noteCaptureSheet: number;
}

export const NotesTable = (props: IProps) => {
    const [previewPopup, setPreviewPopup] = React.useState<boolean>(false);
    const [notesData, setNotesData] = React.useState<Note.SearchDtoIn[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [searchValue, setSearchValue] = React.useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [selectedNoteId, setSelectedNoteId] = React.useState<string>("");
    const [sortColumnNames, setSortColumnNames] = React.useState<string[]>([]);
    const [sortDirections, setSortDirections] = React.useState<SortDirections[]>([]);

    const notesSearchRequest: Note.SearchRequest = {
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        ScorecardId: props.scorecardId,
        SortColumnNames: sortColumnNames,
        SortDirections: sortDirections,
        SearchValue: searchValue,
        ScorecardElements: [props.scorecardElement],
        NoteCaptureSheets: [props.noteCaptureSheet],
        LinkedEntityId: props.linkedEntityId,
        CreatedByUserIds: null,
        ResponsibleUserIds: null,
        Draw: 2,
        SearchLinkedEntity: false
    };


    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }
    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setSortColumnNames([sortOption.ColumnName]);
        setSortDirections([sortOption.SortDirection]);
        setPageNumber(1);

    }

    const handleClosePopup = () => {
        setPreviewPopup(false);
        setSelectedNoteId("");
    }

    const handleEdit = (id: string) => {
        setSelectedNoteId(id);
        setPreviewPopup(true);
    }

    const handleDelete = async (id: string) => {
        try {
            await NoteService.DeleteNote(id, props.scorecardId);
            toast.success("Note deleted succesfully")
            fetchData();

        } catch (error) {
            console.log(error)
        }

    }

    const handleEmail = async (id: string) => {
        try {
            await NoteService.SendNoteToResponsibleUser(id);
            toast.success("Note email sent")
            fetchData();

        } catch (error) {
            console.log(error)
        }

    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await NoteService.SearchNotes(notesSearchRequest);
            if (searchResult.data) {
                setNotesData(searchResult.data.data);
                setFilteredItemsCount(searchResult.data.filteredItemsCount);
                setTotalItemsCount(searchResult.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue, sortColumnNames, sortDirections]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleAddNote = () => {
        setPreviewPopup(true)
    }
    const bulkActions = [
        {
            label: "Add Note",
            action: handleAddNote
        }
    ]

    const notesTableData = NotesTableMapper(notesData, handleEdit, handleDelete, handleEmail);

    return (
        <>
            <AppAccordion expandOnDefault={false} label='Notes'>
                <DataTable
                    table={notesTableData}
                    entriesPerPage={entriesPerPage}
                    pageNumber={pageNumber}
                    filteredItemsCount={filteredItemsCount}
                    totalItemsCount={totalItemsCount}
                    entriesPerPageChanged={entriesPerPageChanged}
                    pageNumberChanged={pageNumberChanged}
                    isLoading={isLoading}
                    canSearch={true}
                    searchValueChanged={searchValueChanged}
                    bulkActions={bulkActions}
                    manualSorting={true}
                    columnSortingChanged={columnSortingChanged}
                ></DataTable>
            </AppAccordion>

            {previewPopup && <NoteModal
                id={selectedNoteId !== "" ? selectedNoteId : undefined}
                scorecardId={props.scorecardId}
                scorecardElement={props.scorecardElement}
                noteCaptureSheet={props.noteCaptureSheet}
                linkedEntityId={props.linkedEntityId}
                handleCancel={handleClosePopup}
                refreshTable={fetchData}
                setNoteId={setSelectedNoteId}
                showNoteModal={previewPopup}
                closeNoteModal={handleClosePopup} />
            }
        </>
    )
}